import React from "react";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import { ToggleButton, ToggleButtonGroup } from "@abb/abb-common-ux-react";
import { MeasurementSetting } from "../../models/settings/MeasurementSettings";

interface IProps {
  settings: MeasurementSetting;
  onToggle: (v: number[]) => void;
  onToggleDeviation: (v: number[]) => void;
}

export default class MeasurementSettingLanding extends React.Component<IProps> {
  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-layout h-100">
            <div className="summary-layout mt-4">
              <div className="col-12">
                <div className="row">
                  <label className="col-4">{t(CONSTANTS.LABLE_CT)}</label>
                  <ToggleButtonGroup
                    monochrome={true}
                    className="ml-2"
                    selected={this.props.settings?.meanTendency}
                    onChange={(v) => this.props.onToggle(v)}
                    sizeClass="medium"
                  >
                    <ToggleButton text={t(CONSTANTS.LABEL_MEAN)} />
                    <ToggleButton text={t(CONSTANTS.LABEL_MEDIAN)} />
                  </ToggleButtonGroup>
                </div>

                <div className="row mt-3">
                  <label className="col-4">
                    {t(CONSTANTS.LABEL_DEVIATION)}{" "}
                  </label>
                  <ToggleButtonGroup
                    monochrome={true}
                    className="ml-2"
                    selected={this.props.settings?.stdDeviation}
                    onChange={(v) => this.props.onToggleDeviation(v)}
                    sizeClass="medium"
                  >
                    <ToggleButton text={t(CONSTANTS.LABEL_STD)} />
                    <ToggleButton text={t(CONSTANTS.LABEL_COV)} />
                  </ToggleButtonGroup>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
